export const geoJsonFilePath = 'data/edu-final.geo.json';
export const hhsDataFilePath = 'data/hhs-data.json';
export const dataFilePath = 'data/edu_data.json';



// WEBPACK FOOTER //
// ./src/config/index.js